export default __webpack_public_path__ + "static/media/unfamiliar.95fef04d.png";